import SpiralGraph from './SpiralGraph'

export default SpiralGraph
